import { z } from 'zod'

import { SecondaryContractDeployment } from '../../../cross-chain-deployment/SecondaryContractDeployment'
import * as FundingAmountSchema from './FundingAmountSchema'
import * as ImplementationContractSchema from './ImplementationContractSchema'
import * as InitializationCalldataSchema from './InitializationCalldataSchema'
import * as ExtraInitializationParamsSchema from './ExtraInitializationParamsSchema'

export const SecondaryContractDeploymentSchema = z.object({
  fundingAmount: FundingAmountSchema.FundingAmountSchema,
  implementationContract: z.string(),
  initializationCalldata: z.string(),
  addPrimaryContractAddress: z.boolean(),
  extraInitializationParams: z.string(),
})

type SecondaryContractDeploymentReportText = z.infer<
  typeof SecondaryContractDeploymentSchema
>

export function mapDomainToReportText(
  secondaryContractDeployment: SecondaryContractDeployment
): SecondaryContractDeploymentReportText {
  return {
    fundingAmount: FundingAmountSchema.mapDomainToReportText(
      secondaryContractDeployment.getFundingAmount()
    ),
    implementationContract: ImplementationContractSchema.mapDomainToReportText(
      secondaryContractDeployment.getImplementationContract()
    ),
    initializationCalldata: InitializationCalldataSchema.mapDomainToReportText(
      secondaryContractDeployment.getInitializationCalldata()
    ),
    addPrimaryContractAddress:
      secondaryContractDeployment.getAddPrimaryContractAddress(),
    extraInitializationParams:
      ExtraInitializationParamsSchema.mapDomainToReportText(
        secondaryContractDeployment.getExtraInitializationParams()
      ),
  }
}

export function mapReportTextToDomain(
  reportText: SecondaryContractDeploymentReportText
): SecondaryContractDeployment {
  const {
    fundingAmount,
    implementationContract,
    initializationCalldata,
    addPrimaryContractAddress,
    extraInitializationParams,
  } = reportText
  return new SecondaryContractDeployment({
    fundingAmount: FundingAmountSchema.mapReportTextToDomain(fundingAmount),
    implementationContract: ImplementationContractSchema.mapReportTextToDomain(
      implementationContract
    ),
    initializationCalldata: InitializationCalldataSchema.mapReportTextToDomain(
      initializationCalldata
    ),
    addPrimaryContractAddress,
    extraInitializationParams:
      ExtraInitializationParamsSchema.mapReportTextToDomain(
        extraInitializationParams
      ),
  })
}
